import { Button, Typography } from "@mui/material";
import ErrorIcon from "../icons/ErrorIcon";
import InfoPage from "./infoPage/InfoPage";

interface Props {
  title?: string;
  subtitle?: string;
  buttonText?: string;
}

const Error = ({ title, subtitle, buttonText }: Props) => {
  return (
    <InfoPage
      Icon={<ErrorIcon />}
      title={title || "Server Error"}
      subtitle={
        <Typography color="textSecondary">
          {subtitle ||
            "We're sorry, something went wrong on our end. \n Our team has been notified and is working on it. \n Please try again later or contact us for assistance."}
        </Typography>
      }
    >
      <Button sx={{ width: "10rem" }} href="/" color="primary" variant="outlined">
        {buttonText || "Home"}
      </Button>
    </InfoPage>
  );
};

export default Error;
